/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.readspeaker", {
        options: {},

        _create () {

            this.sticker = $('.readspeaker__sticker', this.element)
            this.trigger = $('.readspeaker__trigger', this.element)
            this.close = $('.readspeaker__close', this.element)

            this.trigger.on("click", ()=>{
                this.showPanel()
            })
            this.close.on("click", ()=>{
                this.hidePanel()
            })
        },

        showPanel(){
            this.trigger.hide()
            this.close.show()
            this.sticker.show();
        },

        hidePanel(){
            this.trigger.show()
            this.close.hide()
            this.sticker.hide();

            var stopBtn = $('.rsbtn_closer')
            if(stopBtn.length){
                stopBtn.trigger("click")
            }
        }
        
       
    });
})(jQuery);
